import { FC } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router';

import { withTrackedSceneView } from '@portal/common/services/google-analytics';

import { getSessionAccount } from '../store/root-reducer';
import GuestLayout from './GuestLayout';
import { HOME_PATH } from './paths';

const AnonymousRoute: FC = () => {
    const isAuthenticated = !!useSelector(getSessionAccount);

    if (isAuthenticated) {
        return <Navigate to={HOME_PATH} replace />;
    }

    return (
        <GuestLayout>
            <Outlet />
        </GuestLayout>
    );
};

export default withTrackedSceneView(AnonymousRoute);
